import { combineReducers } from 'redux'

import resultados from './consultaPrestacaoContasAnual'
import filtro from './filtro'
import filtroAplicados from './filtroAplicados'

export default combineReducers({ resultados, filtro, filtroAplicados })
